import './publicPath'

const Vue = window.Vue

Vue.component('PermanentCrossSeller', () => import('./PermanentCrossSeller.vue'))
